// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"

import Rails from "@rails/ujs";
Rails.start();

// Share bootstrap to views
window.bootstrap = bootstrap;

import "@oddcamp/cocoon-vanilla-js";

import "./layout";
import "./sortable";
import "./toasts";
import "./clipboard";
import "./bootstrap-elements";
import "./choices";
